import React from 'react'

const ArrowTop = ({className}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" className={className}>
<path d="M16 4V20" stroke="#99A1AF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M22.6668 10.6667L16.0002 4L9.3335 10.6667" stroke="#99A1AF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M28 20V25.3333C28 26.0406 27.719 26.7189 27.219 27.219C26.7189 27.719 26.0406 28 25.3333 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V20" stroke="#99A1AF" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default ArrowTop